module.exports = __webpack_public_path__ + "static/assets/45e6ae4b52bfe3f04bae5bdec8cb4fdd.svg";